import axios, {AxiosResponse} from 'axios'
import {UposlenikModel, Option} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'
import {RezervacijeRolni} from "../models/RezervacijeRolni";
import {PredrezervacijaMaterijalaModel} from "../models/PredrezervacijaMaterijalaModel";
import {RepromaterijaliGreske} from "../models/RepromaterijaliGreske";
import {PredrezervacijaKomentar} from "../models/PredrezervacijaKomentar";

const API_URL = process.env.REACT_APP_API_URL
const API = `${API_URL}/repromaterijali/predrezervacija`
const auth: UposlenikModel = getAuth()!

const headers = {Accept: 'application/json', Authorization: auth?.access_token ?? ''}

export async function getPredrezervacije(
    pageNo: number,
    perPage: number,
    filters?: { uposlenik?: string; status?: number }
) {
    // Initialize the base params
    const params: any = { per_page: perPage, page: pageNo };

    // Add filters to params if they exist
    if (filters?.uposlenik) {
        params.uposlenik = filters.uposlenik;
    }
    if (filters?.status) {
        params.status = filters.status;
    }

    // Make the API request with params
    return await axios.get<Array<PredrezervacijaMaterijalaModel>>(`${API_URL}/repromaterijali/predrezervacija`, {
        headers: headers,
        params: params,
    });
}

export async function getAkitvniProjektiDropdown() {
    return await axios.get<Array<Option>>(`${API_URL}/predrezervacija/akitvniProjektiDropdown`, {headers: headers})
}

export async function savePredrezervacija(Data: any) {
    try {
        const response = await axios.post(API, Data, {headers: headers})
        if (response.data.error === 0) {
            return response.data
        } else {
            return new Error(response.data.message || 'Failed to fetch.')
        }
    } catch (error) {
        return error
    }
}
export async function updatePredrezervacija(Data: any, id: number) {
    try {
        const response = await axios.post(`${API}/${id}?_method=PATCH`, Data, {headers: headers})
        if (response.data.error === 0) {
            return response.data
        } else {
            // Handle any other type of response structure or errors returned from the server here
            return response.data.message || 'Failed to fetch.'
        }
    } catch (error) {
        console.error('Error fetching data:', error)
        return error
    }
}
export async function fetchPredrezervacija(Id: number): Promise<Partial<PredrezervacijaMaterijalaModel>> {
    try {
        const response = await axios.get(`${API}/${Id}`)
        if (response.data && response.data.error === 0) {
            return response.data.data
        } else {
            return response.data.message || 'Failed to fetch.'
        }
    } catch (error: any) {
        return error
    }
}

export async function deletePredrezervacija(id: number) {
    try {
        const response = await axios.delete(`${API}/${id}`, { headers: headers });

        if (response.data?.error === 0) {
            return response;
        } else {
            // Logical API error, throw to handle it in the catch block
            throw new Error(response.data?.message || 'Failed to delete reservation.');
        }
    } catch (error) {
        // Check if the error is an AxiosError
        if (axios.isAxiosError(error) && error.response) {
            // Safely extract the error message from the Axios response
            const errorMessage = error.response.data?.message || 'An unexpected error occurred';
            throw new Error(errorMessage); // Re-throw for the caller to handle
        } else {
            // Handle non-Axios errors
            throw new Error(error instanceof Error ? error.message : 'An unexpected error occurred');
        }
    }
}

export async function getMatchingRepromaterijal(Id: number): Promise<any[]> {
    try {
        const response = await axios.get(`${API_URL}/predrezervacija/getMatchingRepromaterijal`, {
            params: { Id },
        })

        // In your case, response.data is already an array
        if (Array.isArray(response.data)) {
            return response.data
        } else {
            throw new Error('Neočekivan format odgovora sa servera.')
        }
    } catch (error: any) {
        const message =
            error?.response?.data?.message ||
            error.message ||
            'Greška pri pozivanju API-ja.'
        console.error('Greška prilikom dohvata repromaterijala:', message)
        throw new Error(message)
    }
}

export async function getRezervisaneRolne(Id: number): Promise<any[]> {
    try {
        const response = await axios.get(`${API_URL}/predrezervacija/getRezervisaneRolne`, {
            params: { Id },
        })

        // In your case, response.data is already an array
        if (Array.isArray(response.data)) {
            return response.data
        } else {
            throw new Error('Neočekivan format odgovora sa servera.')
        }
    } catch (error: any) {
        const message =
            error?.response?.data?.message ||
            error.message ||
            'Greška pri pozivanju API-ja.'
        console.error('Greška prilikom dohvata repromaterijala:', message)
        throw new Error(message)
    }
}

export async function getKomentariPredrezervacije(Id: number): Promise<any[]> {
    try {
        const response = await axios.get(`${API_URL}/predrezervacija/getAktivniKomentarePredrezevacije`, {
            params: { Id },
        })

        // In your case, response.data is already an array
        if (Array.isArray(response.data)) {
            return response.data
        } else {
            throw new Error('Neočekivan format odgovora sa servera.')
        }
    } catch (error: any) {
        const message =
            error?.response?.data?.message ||
            error.message ||
            'Greška pri pozivanju API-ja.'
        console.error('Greška prilikom dohvata repromaterijala:', message)
        throw new Error(message)
    }
}

export async function getSviKomentarePredrezevacije(Id: number): Promise<any[]> {
    try {
        const response = await axios.get(`${API_URL}/predrezervacija/getSviKomentarePredrezevacije`, {
            params: { Id },
        })

        // In your case, response.data is already an array
        if (Array.isArray(response.data)) {
            return response.data
        } else {
            throw new Error('Neočekivan format odgovora sa servera.')
        }
    } catch (error: any) {
        const message =
            error?.response?.data?.message ||
            error.message ||
            'Greška pri pozivanju API-ja.'
        console.error('Greška prilikom dohvata repromaterijala:', message)
        throw new Error(message)
    }
}
export async function imamLiAktivanKomentar(IdUposlenika: number): Promise<PredrezervacijaKomentar[]> {
    try {
        const response = await axios.get(`${API_URL}/predrezervacija/getAktivniKomentarePredrezevacije`, {
            params: { IdUposlenika },
        });

        if (Array.isArray(response.data)) {
            return response.data;
        }
        console.log(response, 'response')
        throw new Error('Neočekivan format odgovora sa servera.');
    } catch (error: any) {
        const message =
            error?.response?.data?.message || error.message || 'Greška pri pozivanju API-ja.';
        console.error('Greška prilikom dohvata komentara:', message);
        throw new Error(message);
    }
}

export async function potvrdiPrekiniPredrezervaciju(Data:any) {
    try {
        const response = await axios.post(`${API_URL}/predrezervacija/potvrdiPrekiniPredrezervaciju`, Data, {headers: headers})
        if (response.data.error === 0) {
            return response.data
        } else {
            return new Error(response.data.message || 'Failed to fetch.')
        }
    } catch (error) {
        return error
    }

}


